export enum AppointmentStatus {
  CREATED = 0,
  OPEN = 1,
  DONE = 2,
  CLOSED = 3,
  END = 4
}

